var module = angular.module('octopusApp.projects');

module.config(function($stateProvider) {

    $stateProvider.state('app.project.variables', {
        url: '/variables',
        templateUrl: 'areas/projects/variables/layout.html',
        layout: {
            projectTab: 'variables'
        },
        defaultSubRoute: 'app.project.variables.project'
    });


    $stateProvider.state('app.project.variables.project', {
        url: '/project',
        templateUrl: 'areas/projects/variables/project_variables.html',
        controller: 'ProjectVariablesController',
        layout: {
            variableTab: 'variables'
        }
    });


    $stateProvider.state('app.project.variables.projectvariabletemplates', {
        url: '/projectvariabletemplates',
        templateUrl: 'areas/projects/variables/project_variables_templates.html',
        controller: 'ProjectVariableTemplatesController',
        layout: {
            variableTab: 'projectvariabletemplates'
        }
    });


    $stateProvider.state('app.project.variables.commonvariabletemplates', {
        url: '/commonvariabletemplates',
        templateUrl: 'areas/projects/variables/project_variables_common_templates.html',
        controller: 'ProjectVariableCommonTemplatesController',
        layout: {
            variableTab: 'commonvariabletemplates'
        }
    });


    $stateProvider.state('app.project.variables.libraryvariabletemplates', {
        url: '/library',
        templateUrl: 'areas/projects/variables/project_variables_library.html',
        controller: 'ProjectVariablesLibraryController',
        layout: {
            variableTab: 'library'
        }
    });


    $stateProvider.state('app.project.variables.all', {
        url: '/all',
        templateUrl: 'areas/projects/variables/project_variables_all.html',
        controller: 'ProjectVariablesAllController',
        layout: {
            variableTab: 'all'
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/variables/project_variables_module.js
// module id = 2802331138753386
// module chunks = 1